import { type Configuration, LogLevel } from '@azure/msal-browser';

import { b2cKnownAuthority, b2cScope, b2cSignInAuthority, clientId, redirectUri } from 'watchtower-ui/utils/Constants';

export const apiScopes = {
  watchtowerApi: [b2cScope],
  openId: ['openid', 'profile', 'email'],
};

const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: b2cSignInAuthority,
    knownAuthorities: [b2cKnownAuthority],
    redirectUri,
    postLogoutRedirectUri: redirectUri,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          default:
            console.warn(`Unexpected log level: ${level}`);
        }
      },
    },
  },
};
export default msalConfig;
